<template>
  <div>
    <!-- 标题 -->
    <img src="../../static/img/ejymjpg.png" alt="" width="100%">
    <div class="btcss">
      <div class="tabbox">
        <div  :class="{'active':active_btn1==index}"  v-for="(item,index) in xmlist" @click="newsList1(index,item)">{{item.name}}</div>
      </div>
    </div>
    <div v-if="noData" class="nodata">暂无数据</div>
    <div v-if="wzshow" style="width:90%;min-height: 500px; cursor: pointer"><img src="../../static/img/yzxckdk.jpg"  @click="openPdf" alt="" style="padding-left: 45%;padding-top: 10%;"></div>
    <div style="width: 90%;margin: 100px 5% 0 5%;min-height: 800px" v-if="detailsShow">
      <div v-html="ejDetail" ></div>
    </div>
  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 111;
export default {
  name: 'Ejml',
  data() {
    return {
      active_btn1:0,
      xmlist: [],
      ejDetail: '',
      visible: false,
      noData: false,
      api,
      activeIndex: '1',
      activeIndex2: '1',
      form: {},
      rules: {},
      dataTime: '',
      imgList: [],
      columnData: [],
      outsideList: [],
      ruleForm: [],
      fileList: [],
      detailsShow:true,
      wzshow:false,
      urlIndex:'',
      titleList:[
        {name:'走进神力'},
        {name:'郑重声明'},
        {name:'齐全的荣誉证照'},
        {name:'完善的资质证书'},
        {name:'企业规划优势'},
        {name:'招商优惠政策'},
      ],
    }
  },
  created() {
    this.target = this.$route.query.target
    console.log(this.$route.query);
    this.urlIndex= this.$route.query.index
    if (this.urlIndex){
      this.active_btn1 = this.urlIndex
    }
    this.searchList(encodeURIComponent(this.$route.query.param))
  },
  mounted() {

  },
  methods: {
    searchList(param){
      let that = this;
      let data ={
        deptId:deptId,
        param:decodeURIComponent(param)
      }
      that.$axios.post(api + '/site/globalSearch?deptId=' + deptId + '&param=' + decodeURIComponent(param) , {

        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          console.log('判断前的数据',res.data);
          let newArr = []
          res.data.data.forEach(item =>{
            if (item.type == 'column'){
              newArr.push(item)
            }
          })
          console.log(11111,newArr);
          that.xmlist = newArr
          console.log(222,that.xmlist);
          if(that.xmlist.length > 0){
            that.lbList('',that.urlIndex)
          }else{
            that.noData = true
          }

        } else {
          that.$message.error(res.data.msg);
        }
      })
    },
    openPdf(){
      if(this.fileList[0].target !=''){
        window.open(this.api  + this.fileList[0].target)
      }else{
        alert('暂无数据')
      }
    },
    newsList1(index,item){
      this.active_btn1 = index
      this.ejDetail = this.xmlist[this.active_btn1].perms
      this.lbList(item.id,this.active_btn1)
      this.wzshow = false
      this.detailsShow = true
      if(item.menuType == 'C'&&item.target !=''){
        window.open(this.api  + item.target)
      }
    },
    //获取列表
    lbList(ids,index) {
      let that = this;
      var id
      if (ids){
        id = ids
      }else {
        id = that.xmlist[0].id
      }
      // id = this.$route.query.id
      that.$axios.post(api + '/site/columnDetail', {
        columnId:id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          //c新窗口打开时获取值
          that.fileList = res.data.data
          if (res.data.data.length > 0){
            that.noData = false
            console.log('index11',index,res.data.data);

            that.ejDetail = res.data.data[0].perms

            if (that.xmlist[that.active_btn1].menuType === 'M'){
            }
            if (that.xmlist[that.active_btn1].menuType === 'C'){
              that.wzshow = true
              that.detailsShow = false
            }else {
              that.wzshow = false
              that.detailsShow = true
            }
          }else {
            that.noData = true
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },

  }
}
</script>
<style>
.nodata{
  text-align: center;
}
.btcss{
  border-bottom:  rgba(110,110,110,1) solid 1px;
  margin-bottom: 30px;
  overflow: hidden;
  line-height: 37px;
}
.active {
  color: #008D40;
  font-weight: 600;
  border-bottom: #0dcc73 solid 3px;
}
.tabbox div{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  min-width: 80px;
  cursor: pointer;
  padding: 5px 2px;
  margin-left: 20px;
  text-align: center;
  width: calc(100%/4 - 50px)!important;
}
.tabbox{
  display: flex;
  width: 93%;
  padding: 0px 15px 0 15px;
  justify-content: space-between;
  margin-left: 45px;
  float: left;
  flex-wrap: wrap;
  /*justify-content:space-around;*/
  /*font-weight: bold;*/
}

body,
html {
  height: 100%;
  margin: 0;
}

#app {
  height: 100%;
  width: 100%;
  /*background-image: url(../../static/img/939939bfb61178f5b4706ec7ed06302.jpg);*/
  background-size: 100% 100%;
}

.bt {
  background-image: url(../../static/img/3e335a61c60a1f37dbe724dd45f0090f_10121_1465_75.png);
  color: #FFFFFF;
  width: 100%;
  text-align: center;
  align-content: center;
  margin: 0;
}


.el-dialog__wrapper {
  overflow: hidden;
}
</style>
